import { Col, Modal, Row } from "react-bootstrap";
import React, { useContext } from "react";

import Card from "../cards/Card";
import { ModalContext } from "../../context/contextProvider";
import PropTypes from "prop-types";
import { ThemeColorsEnum } from "../../constants/enums";

const SideView = ({
  color = ThemeColorsEnum.default,
  content,
  title,
  onClose = () => {},
  size = "md",
  visible,
  ...otherProps
}) => {
  const { closeSideView } = useContext(ModalContext);

  const handleClose = () => {
    closeSideView();
    onClose();
  };

  return (
    
      <Card className='card-left' color={color}>
        {title && (
          <Card.Header>
            <h2 className="card-title">{title}</h2>
          </Card.Header>
        )}
        {/* if you pass content it will be used instead of body and buttons */}
        {content ? (
          <>
            <Card.Body>{content}</Card.Body>
          </>

        ) : null}
      </Card>
  );
};

SideView.propTypes = {
  isFeatured: PropTypes.bool,
};

export default SideView;
